/**
 * Rangi kont — JEDEN słownik dla całej aplikacji (menu, nagłówek, moduł Użytkownicy,
 * eksporty). Wartości liczbowe są lustrem backendu (User.Type, komentarz w User.cs):
 *
 *  1 = OBSŁUGA     — pracownik Krosno Glass; widzi wnioski swoje i swoich stref,
 *                    to jego przypisuje się do stref dostępu.
 *  2 = WIZYTATOR   — osoba zewnętrzna (konto z portalu — samodzielna rejestracja albo
 *                    kartoteka założona przez obsługę). Zupełnie inny widok, nigdy nie
 *                    widzi cudzych danych. Tej rangi NIE nadaje się ręcznie.
 *  3 = ADMINISTRATOR — pełny dostęp do wszystkiego.
 *  4 = OCHRONA     — służba ochrony; automatycznie widzi WSZYSTKIE przepustki
 *                    (weryfikacja QR, pełny rejestr), bez modułów administracyjnych.
 */
export const USER_TYPES = {
    OBSLUGA: 1,
    WIZYTATOR: 2,
    ADMINISTRATOR: 3,
    OCHRONA: 4,
};

export const USER_TYPE_LABELS = {
    1: "Obsługa",
    2: "Wizytator",
    3: "Administrator",
    4: "Ochrona",
};

/** Opisy do formularza nadawania rangi — administrator ma wiedzieć, CO nadaje. */
export const USER_TYPE_DESCRIPTIONS = {
    1: "Pracownik Krosno Glass — widzi wnioski swoje i swoich stref dostępu.",
    2: "Osoba zewnętrzna z portalu — konto zarządzane w kartotekach, nie tutaj.",
    3: "Pełny dostęp do wszystkich modułów i danych.",
    4: "Służba ochrony — widzi wszystkie przepustki i weryfikuje QR, bez modułów administracyjnych.",
};
